import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import { useSelector } from 'react-redux'
import classnames from 'classnames'

import { selectBuyerWelcomeVideoId, selectBuyerWelcomeVideoType, selectBuyerWelcomeVideoUrl } from '../../../../store/selectors/videos'
import { selectCustomerFirstName } from '../../../../store/selectors/customerProfile'
import { Player } from '../../../shared/Player'
import {
  Box,
  Button,
  Flex,
  Heading,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text
} from '@homebotapp/hb-react-component-catalog'
import { useEffect } from 'react'

export interface BuyerWelcomeVideoModalProps {
  handleSubmitClick: () => void
}

const BuyerWelcomeVideoModal = ({ handleSubmitClick }: BuyerWelcomeVideoModalProps) => {
  const videoId = useSelector(selectBuyerWelcomeVideoId)
  const videoType = useSelector(selectBuyerWelcomeVideoType)
  const videoUrl = useSelector(selectBuyerWelcomeVideoUrl)
  const customerFirstName = useSelector(selectCustomerFirstName)

  useEffect(() => {
    if (!videoId || !videoType) {
      handleSubmitClick()
      return
    }
  }, [])

  return (
    <Modal onClose={() => null} onOverlayClick={() => null} isOpen={true}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>
          <Heading textAlign='left' size='xs'>
            <FormattedMessage id='BuyerWelcomeVideo.title' defaultMessage='👋 Welcome to your For You page!' />
          </Heading>
        </ModalHeader>
        <ModalBody paddingBottom={10}>
          <Box>
            <Text as='span'>
              <Text fontWeight={600} variant='neutralCool'>
                <FormattedMessage
                  id='BuyerWelcomeVideo.subTitle1'
                  defaultMessage='This is your home for all things homebuying.'
                />
              </Text>
              <Text> </Text>
              <Text variant='neutralCool'>
                <FormattedMessage
                  id='BuyerWelcomeVideo.subTitle2'
                  defaultMessage='Here’s a short video from {customerFirstName} to get you started!'
                  values={{
                    customerFirstName: customerFirstName as string
                  }}
                />
              </Text>
            </Text>
            <Box>
              <Player videoType={videoType} videoId={videoId} videoUrl={videoUrl} />
            </Box>
          </Box>
        </ModalBody>
        <ModalFooter>
          <Button as={Flex} alignSelf='flex-end' size='sm' colorScheme='primary' onClick={handleSubmitClick}>
            <FormattedMessage id='BuyerWelcomeVideo.button' defaultMessage="Let's go!" />
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  )
}

export default BuyerWelcomeVideoModal
